module.exports = "/images/trash.svg?ffe5e9da44027c6e860d37e4bf5984a2";